<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
    components: {
        PageHeader,
    },
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            channelName: '',
            instanceId: '',
            token: '',
            clientToken: '',
            phoneNumber: '',
            openAsPending: true,
        };
    },
    computed: {
        ...mapGetters({
            uiFlags: 'inboxes/getUIFlags',
        }),
    },
    validations: {
        channelName: { required },
        instanceId: { required },
        token: { required },
        clientToken: { required },
        phoneNumber: { required },
    },
    methods: {
        async createChannel() {
            this.v$.$touch();
            if (this.v$.$invalid) {
                return;
            }

            try {
                const zapiChannel = await this.$store.dispatch(
                    'inboxes/createChannel',
                    {
                        name: this.channelName,
                        channel: {
                            type: 'z_api',
                            instance_id: this.instanceId,
                            token: this.token,
                            client_token: this.clientToken,
                            phone_number: this.phoneNumber,
                            open_as_pending: this.openAsPending,
                        },
                    }
                );

                router.replace({
                    name: 'settings_inboxes_add_agents',
                    params: {
                        page: 'new',
                        inbox_id: zapiChannel.id,
                    },
                });
            } catch (error) {
                useAlert(
                    error.message || 'Erro ao criar canal Z-API'
                );
            }
        },
    },
};
</script>

<template>
    <div
        class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0">
        <PageHeader header-title="Configurar Z-API"
            header-content="Configure sua instância Z-API para receber e enviar mensagens do WhatsApp" />
        <form class="flex flex-wrap mx-0" @submit.prevent="createChannel()">
            <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
                <label :class="{ error: v$.channelName.$error }">
                    Nome do Canal
                    <input v-model="channelName" type="text" placeholder="Digite um nome para o canal"
                        @blur="v$.channelName.$touch" />
                    <span v-if="v$.channelName.$error" class="message">
                        Nome do canal é obrigatório
                    </span>
                </label>
            </div>

            <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
                <label :class="{ error: v$.instanceId.$error }">
                    Instance ID
                    <input v-model="instanceId" type="text" placeholder="Digite o Instance ID da sua Z-API"
                        @blur="v$.instanceId.$touch" />
                </label>
            </div>

            <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
                <label :class="{ error: v$.token.$error }">
                    Token
                    <input v-model="token" type="password" placeholder="Digite o Token da sua Z-API"
                        @blur="v$.token.$touch" />
                </label>
            </div>

            <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
                <label :class="{ error: v$.clientToken.$error }">
                    Client Token
                    <input v-model="clientToken" type="password" placeholder="Digite o Client Token da sua Z-API"
                        @blur="v$.clientToken.$touch" />
                </label>
            </div>

            <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
                <label :class="{ error: v$.phoneNumber.$error }">
                    Número do WhatsApp
                    <input v-model="phoneNumber" type="text" placeholder="Ex: +5511999999999"
                        @blur="v$.phoneNumber.$touch" />
                </label>
            </div>

            <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
                <label class="flex items-center space-x-2">
                    <woot-switch id="sla_bh" v-model="openAsPending" />
                    <span>Abrir como pendente</span>
                </label>
            </div>

            <div class="w-full">
                <woot-submit-button :loading="uiFlags.isCreating" button-text="Criar Canal Z-API" />
            </div>
        </form>
    </div>
</template>